<template>
  <div class="home">
    <n-modal v-model:show="show_add_black_box" preset="dialog" title="请添加黑名单" positive-text="确认" negative-text="取消"
      @positive-click="AddBlackList" @negative-click="CancelBlack">
      <div class="input-amount-box">
        <NInput v-model:value="dealer_name" placeholder="请输入荷官名称"></NInput>
      </div>
    </n-modal>

    <n-modal v-model:show="show_amount_box" preset="dialog" title="设置账号余额" positive-text="确认" negative-text="取消"
      @positive-click="SubmitSetAmount" @negative-click="CancelSetAmount">
      <div class="input-amount-box">
        <div class="content">
          <span>账号: {{ selectUser.userName }}</span>
          <span>当前余额:{{ selectUser.credit }}</span>
        </div>
        <NInputNumber v-model:value="set_amount" placeholder="请输入要增加或减少的额度"></NInputNumber>
      </div>
    </n-modal>

    <NCard class="card-box" title="SASS系统">
      <NTabs :style="{ height: '100%' }" pane-class="tab-pane-box" size="small" type="line" animated>
        <NTabPane name="1" tab="全局设置">
          <NForm class="form-box" label-placement="left" label-width="auto">
            <NFormItem label="头部保留局">
              <NInputNumber v-model:value="input.HeaderReserveJuNumber" :show-button="false" :max="1000" :min="0">
              </NInputNumber>
            </NFormItem>
            <NFormItem label="搜索索引">
              <NInputNumber v-model:value="input.SearchStartIndex" :show-button="false" :max="1000" :min="0">
              </NInputNumber>
            </NFormItem>
            <NFormItem label="忽略局">
              <NInputNumber v-model:value="input.IgnoreJuNumber" :show-button="false" :max="1000" :min="1">
              </NInputNumber>
            </NFormItem>
            <NFormItem label="尾部保留局">
              <NInputNumber v-model:value="input.EndReserveJuNumber" :show-button="false" :max="1000" :min="2">
              </NInputNumber>
            </NFormItem>
            <NFormItem label="最低启动金额">
              <NInputNumber v-model:value="input.KillStartAmount" :show-button="false" :min="0">
              </NInputNumber>
            </NFormItem>
          </NForm>
          <div class="button-box">
            <NButton class="seting-btn" type="success" @click="SetKillPigConfig()">设置</NButton>
          </div>
        </NTabPane>

        <NTabPane name="2" tab="受控房间">
          <n-transfer v-model:value="selectRooms" :options="roomList" source-filterable />
          <NButton type="info" @click="SetKillPigAsync()">设置勾选启用</NButton>
        </NTabPane>
        <NTabPane style="display: flex; flex-direction: column" name="3" tab="对局面板">
          <n-select class="select-room" v-model:value="currentRoom" :options="selectRoomOptions" />
          <n-space style="display: flex; flex-direction: column; flex-grow: 1" vertical>
            <!-- <n-slider v-model:value="markValue" range :marks="marks" :step="10" /> -->

            <n-space>
              <div class="row">
                <n-tag type="success">
                  房间号:{{ selectRoomVo?.RoomNumber }}
                </n-tag>
                <n-tag type="success">
                  当前局号:{{ selectRoomVo?.VirtualJuNumber }}
                  {{ selectRoomVo?.VirtualChildJuNumber }}
                </n-tag>
                <n-tag type="success">
                  游戏状态:{{ selectRoomVo?.VirtualST }}
                </n-tag>
                <n-tag type="success">
                  荷官:{{ selectRoomVo?.VirtualDealer }}
                </n-tag>
              </div>
              <div class="row">
                <n-tag type="warning">
                  游戏包索引:{{ selectRoomVo?.NextIndex }}/{{
                    selectRoomVo?.CacheGameInfoCount
                  }}
                </n-tag>
                <n-tag type="warning">
                  锚点:{{ selectRoomVo?.GameInfoStatusPointCount }}个
                </n-tag>
                <div class="video-dic">
                  <div class="video-item" v-for="(v, k) in selectRoomVo?.VideoDataDic">
                    <n-tag type="info">视频{{ v.VideoName }}索引</n-tag>
                    <n-tag type="error">
                      {{ v.CurrentIndex }}/{{ v.AllIndexCount }}
                    </n-tag>
                  </div>
                </div>
              </div>
            </n-space>
          </n-space>

          <div class="game-map-list">
            <div class="game-map-item" v-for="v in maps">
              <span v-if="v == 1" class="dou zhuang">庄</span>
              <span v-else-if="v == 2" class="dou xian">闲</span>
              <span v-else-if="v == 3" class="dou he">和</span>
            </div>
          </div>

          <!-- <NVirtualList class="log-list" :item-size="42" :items="logs">
            <template #default="{ item }">
              <div class="log-item" style="height: 42px">
                <NTag class="key" type="info">{{ item.key }}</NTag>
                <NTag class="value" type="default">{{ item.value }}</NTag>
              </div>
            </template>
</NVirtualList> -->
        </NTabPane>

        <NTabPane name="4" tab="账号充值">
          <div class="user-list">
            <div class="user-item" v-for="v in userList">
              <div class="left">
                <span>账号:{{ v.userName }}</span>
                <span>余额: <NTag type="warning">{{ v?.credit ?? 0 }}</NTag></span>
              </div>
              <NButton class="set-amount-btn" @click="ShowSetAmount(v)">设置余额</NButton>
            </div>
          </div>
        </NTabPane>

        <NTabPane name="5" tab="黑名单">
          <div class="block-box">
            <div class="black-list">
              <div class="black-item" v-for="v in blockList">
                <div class="left">
                  <span>荷官:{{ v.dealer_name }}</span>
                </div>
                <n-popconfirm @positive-click="DeleteBlack(v.id!)">
                  <template #trigger>
                    <n-button type="error">删除</n-button>
                  </template>
                  您确定要删除 “{{ v.dealer_name }}” 吗?
                </n-popconfirm>
              </div>
            </div>
            <NButton class="black-button" type="primary" @click="TryAddBlockList">添加黑名单</NButton>
          </div>
        </NTabPane>
      </NTabs>
    </NCard>

    <div class="bottom-box">

      <n-popconfirm @positive-click="RestartService">
        <template #trigger>
          <NButton style="width: 100%;" type="error">重启服务</NButton>
        </template>
        重启服务后,需大概等待10秒，在尝试登录!
      </n-popconfirm>


    </div>

  </div>
</template>

<script setup lang="ts">
import virtual_blacklist from "@/ts/dbvo/virtual_blacklist";
import SignalRClient from "@/ts/SignalRClient";
import Tools from "@/ts/Tools";
import KillPigConfigVO from "@/ts/VO/KillPigConfigVO";
import OutPutStopService from "@/ts/VO/OutPutStopService";
import RoomVO from "@/ts/VO/RoomVO";
import { computed } from "@vue/reactivity";
import {
  createDiscreteApi,
  NAlert,
  NButton,
  NCard,
  NForm,
  NFormItem,
  NInput,
  NInputNumber,
  NSlider,
  NSwitch,
  NTabPane,
  NTabs,
  NTag,
  NVirtualList,
  useMessage,
} from "naive-ui";
import { onMounted, ref } from "vue";

type OutPutGetAllBlockList = {
  flag: boolean;
  errorMessage: string;
  list: virtual_blacklist[];
};

type OutPutMessage = {
  flag: boolean;
  errorMessage: string;
};

const api = createDiscreteApi(["message"]);

const show_add_black_box = ref(false);
/**
 * 是否显示余额框
 */
const show_amount_box = ref<boolean>(false);
const set_amount = ref<number>();
const dealer_name = ref<string>();

//#region 受控房间

const roomList = ref<RoomVO[]>([]);
const userList = ref<any[]>([]);
const blockList = ref<virtual_blacklist[]>([]);

const selectUser = ref<any>({});

const selectRooms = ref<(string | number)[]>([]);

//#endregion

//#region 对局面板
const currentRoom = ref<string | number>();
const selectRoomOptions = computed(() => {
  const dlist: {
    label: string;
    value: string;
  }[] = [];
  if (selectRooms.value != null) {
    for (let i = 0; i < selectRooms.value!.length; i++) {
      const vd = selectRooms.value[i];
      for (let k = 0; k < roomList.value.length; k++) {
        const kd = roomList.value[k];
        if (kd.RoomNumber == vd) {
          dlist.push({
            label: kd.label,
            value: kd.value,
          });
          break;
        }
      }
    }
  }
  return dlist;
});

/**
 * 当前选择的房间对象
 */
const selectRoomVo = computed(() => {
  const room = roomList.value.find((x) => x.RoomNumber == currentRoom.value);
  return room;
});

const maps = computed(() => {
  const list = selectRoomVo.value?.VirtualMapsDecoding?.map((x) => x);
  return list ?? [];
});

//日志列表
const logs = ref<
  {
    key: string;
    value: string;
  }[]
>([]);
for (let i = 0; i < 1000; i++) {
  logs.value!.push({
    key: `测试${i}`,
    value: "成功连接到服务器",
  });
}

//#endregion

// const marks = ref({
//   34: '太棒了',
//   75: '不错'
// });
// const markValue = ref([50, 70]);

const input = ref<KillPigConfigVO>(new KillPigConfigVO());

async function InitAsync() {
  /**
   * 获取杀猪配置
   */
  GetKillPigConfig();
  GetUserListAsync();
  GetAllBlockListAsync();

  var respRoomObj = await SignalRClient.Instance.InvokeAsync<{
    [key: string]: RoomVO;
  }>("GetRoomList");
  for (const key in respRoomObj) {
    const room = respRoomObj[key];
    Object.setPrototypeOf(room, RoomVO.prototype);
    if (room.OpenKillPig) {
      selectRooms.value?.push(room.RoomNumber);
    }
    roomList.value.push(room);
  }
}

/**
 * 获取用户列表
 */
async function GetUserListAsync() {
  Tools.FetchGetAsync<{
    allcount: number;
    pagecount: number;
    data: any;
  }>("Game/GetUserList", {
    page: 1,
    pageSize: 100,
  }).then((resp) => {
    if (resp.CheckIsOk()) {
      userList.value = resp.Data?.data;
    }
  });
}

/**
 * 获取黑名单列表
 */
async function GetAllBlockListAsync() {
  var blockListItem =
    await SignalRClient.Instance.InvokeAsync<OutPutGetAllBlockList>(
      "GetAllBlockList"
    );
  if (blockListItem.flag) {
    blockList.value = blockListItem.list;
  }
}

/**
 * 添加黑名单
 */
function AddBlackList() {
  SignalRClient.Instance.InvokeAsync<OutPutMessage>(
    "AddBlockList",
    dealer_name.value
  ).then((resp) => {
    if (!resp.flag) {
      Tools.AlertError(resp.errorMessage);
    } else {
      Tools.AlertSuccess("添加成功!");
      GetAllBlockListAsync();
    }
  });
}

/**
 * 删除黑名单
 */
function DeleteBlack(id: number) {
  SignalRClient.Instance.InvokeAsync<OutPutMessage>(
    "RemoveBlockFromID",
    id
  ).then((resp) => {
    if (!resp.flag) {
      Tools.AlertError(resp.errorMessage);
    } else {
      Tools.AlertSuccess("删除成功!");
      GetAllBlockListAsync();
    }
  });
}

/**
 * 尝试添加黑名单
 */
function TryAddBlockList() {
  dealer_name.value = "";
  show_add_black_box.value = true;
}

/**
 * 设置勾选启用
 */
async function SetKillPigAsync() {
  var roomlist = selectRooms.value;
  var flag = await SignalRClient.Instance.InvokeAsync<boolean>(
    "SetKillPig",
    roomlist
  );
  if (flag) {
    api.message.success("设置成功");
  } else {
    api.message.error("设置失败");
  }
}

async function GetRoomDataAsync() {
  const roomNumber = currentRoom.value;
  let gameType: string = "";
  let gameCode: string = "";
  if (roomNumber != null && roomNumber != "") {
    let arr = `${roomNumber}`.split("-");
    gameType = arr[0];
    gameCode = arr[1];
  } else {
    return;
  }
  let room = await SignalRClient.Instance.InvokeAsync<RoomVO>(
    "GetRoomData",
    gameType,
    gameCode
  );
  if (room) {
    Object.setPrototypeOf(room, RoomVO.prototype);
    for (let i = 0; i < roomList.value.length; i++) {
      const v = roomList.value[i];
      if (v.RoomNumber == room.RoomNumber) {
        roomList.value[i] = room;
        debugger;
        break;
      }
    }
  }
}

/**
 * 获取杀猪配置
 */
function GetKillPigConfig() {
  SignalRClient.Instance.InvokeAsync<KillPigConfigVO>("GetKillPigConfig").then(
    (x) => {
      input.value = x;
    }
  );
}

function AddBlack() {
  SignalRClient.Instance.InvokeAsync<OutPutMessage>("GetKillPigConfig").then(
    (v) => {
      if (!v.flag) {
        Tools.AlertError(v.errorMessage);
        return;
      }
      Tools.AlertSuccess("添加成功!");
      GetAllBlockListAsync();
    }
  );
}

function CancelBlack() {
  show_add_black_box.value = false;
}

/**
 * 充值服务
 */
function RestartService() {
  SignalRClient.Instance.InvokeAsync<OutPutStopService>("RestartService").then(
    (x) => {
      if (x.Ok) {
        Tools.AlertSuccess("重启服务命令已成功发送,等待10秒后，重新尝试登录!");
      }
      else {
        Tools.AlertError(x.ErrorMessage);
      }
    }
  );
}

/**
 * 设置杀猪配置
 * @param config
 */
function SetKillPigConfig() {
  SignalRClient.Instance.InvokeAsync<KillPigConfigVO>(
    "SetKillPigConfig",
    input.value
  ).then((x) => {
    if (x) {
      api.message.success("设置成功!");
    } else {
      api.message.error("设置失败!");
    }
  });
}

/**
 * 显示设置金额
 * @param v
 */
function ShowSetAmount(v: any) {
  selectUser.value = v;
  //显示窗口
  set_amount.value = undefined;
  show_amount_box.value = true;
}

/**
 * 确认充值
 */
function SubmitSetAmount() {
  Tools.FetchGetAsync("Game/SetUserAmountFromUserName", {
    userName: selectUser.value.userName,
    amount: set_amount.value,
  }).then((resp) => {
    if (resp.CheckIsOk()) {
      Tools.AlertSuccess("设置成功!");
      GetUserListAsync();
    }
  });
}

/**
 * 取消
 */
function CancelSetAmount() { }

setInterval(GetRoomDataAsync, 2000);

InitAsync();
</script>

<style scoped lang="scss">
.home {
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  overflow: hidden;

  .card-box {
    width: 100%;
    height: 100%;
    padding: 10px;
    overflow: hidden;

    .tab-pane-box {
      height: 100%;
      display: flex;
      flex-direction: column;
    }

    .form-box {
      display: flex;
      flex-grow: 1;
      flex-direction: column;
    }

    .button-box {
      margin-top: auto;

      .seting-btn {
        width: 100%;
      }
    }
  }
}

.game-map-list {
  display: flex;
  flex-wrap: wrap;
  flex-grow: 1;
  overflow-y: auto;
  // height: 30vh;

  .game-map-item {
    display: flex;
    margin: 2px;

    .dou {
      width: 20px;
      height: 20px;
      border-radius: 50%;
      display: flex;
      align-items: center;
      justify-content: center;
    }

    .zhuang {
      background-color: rgb(255, 51, 51);
    }

    .xian {
      background-color: rgb(1, 103, 255);
    }

    .he {
      background-color: rgb(0, 204, 0);
    }
  }
}

.log-list {
  flex-grow: 1;
  max-height: 30vh;
  margin-top: auto;

  .log-item {
    display: flex;
    align-items: center;

    .key {
      margin-right: 5px;
    }

    .value {}
  }
}

.user-list {
  display: flex;
  flex-direction: column;
  overflow-y: auto;
  flex-grow: 1;
  max-height: 80vh;

  .user-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    background-color: rgb(51, 51, 51);
    border-radius: 10px;
    margin-bottom: 10px;
    padding: 20px;

    .left {
      display: flex;
      flex-direction: column;
    }

    .set-amount-btn {
      margin-left: auto;
    }
  }
}

.input-amount-box {
  display: flex;
  flex-direction: column;

  .content {
    display: flex;
    justify-content: space-between;
  }
}

.block-box {
  display: flex;
  flex-direction: column;
  // flex-grow: 1;
  max-height: 80vh;
  width: 100%;

  .black-list {
    display: flex;
    flex-direction: column;
    overflow-y: auto;

    &::-webkit-scrollbar {
      width: 0px;
      height: 0px;
    }

    .black-item {
      display: flex;
      width: 100%;
      justify-content: space-between;
      margin-bottom: 10px;
      margin: 5px 0px;
    }
  }

  .black-button {
    width: 100%;
  }
}
</style>
